import { IBaseObjectFacade } from "../../store/facade/i-base-object.facade";
import { Observable } from "rxjs/Observable";
import { BaseObject } from "./base-object.model";
import { StoreFacade } from "../../store/facade/store-facade";
import { ActionOptionsArgs } from "../../store/actions/base-actions";
import { of } from "rxjs/observable/of";

export abstract class BaseObjectStoreFacade<T extends BaseObject> extends StoreFacade implements IBaseObjectFacade<T> {

    abstract getAll(): Observable<Array<T>>;

    abstract create(object: T): void;
    abstract update(object: T): void;
    abstract remove(object: T, options?: ActionOptionsArgs): void;
    abstract insert(object: T): void;

    get(id: string): Observable<T> {
        return this.getAll().map(objects => objects.find(object => object.id === id));
    }

    getBy(selector: (object: T) => boolean): Observable<Array<T>> {
        return this.getAll().map(objects => objects ? objects.filter(selector) : []);
    }

    upsert(object: T): void {
        if (this.exists(object.id)) {
            this.update(object);
        } else {
            this.create(object);
        }
    }

    exists(id: string): boolean {
        let found = false;
        this.get(id).take(1).subscribe(item => found = !!item);
        return found;
    }

    protected removeBy(test: (object: T) => boolean, options?: ActionOptionsArgs): void {
        this.getAll().take(1).subscribe(objects => objects.filter(test).forEach(object => this.remove(object, options)));
    }

    canDelete(object: T): Observable<boolean> {
        return of(true);
    }

    checkCanDelete(object: T): void {
        this.canDelete(object).take(1).subscribe(result => {
            if (!result) {
                throw new Error("NOT_AUTHORISED_ACTION");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/base-object/base-object.store-facade.ts